import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlSendOrderToRestaurant = `${webUrlBase}api/mobile/table_orders/send_to_restaurant`
export const urlCloseDeliveryOrder = (order_id) => `${webUrlBase}api/mobile/table_orders/${order_id}/finish_user_order`;
export const urlUploadWireTransferReceipt = (order_id) => `${webUrlBase}api/mobile/user_orders/${order_id}/wire_transfer_receipt`;
export const urlUpdateDeliveryInfo = `${webUrlBase}api/mobile/user_orders/update_delivery_info`;